import { Reveal, Overline } from "./Reveal";

const FOTOS = [
  { src: "/img/gente/familia-auto.jpg", label: "Familias en ruta" },
  { src: "/img/gente/amigos.jpg", label: "Amigos" },
  { src: "/img/gente/pareja.jpg", label: "Parejas" },
  { src: "/img/gente/negocios.jpg", label: "Viajes de negocios" },
  { src: "/img/gente/familia-playa.jpg", label: "Familias con niños" },
  { src: "/img/gente/amigas.jpg", label: "Escapadas de amigas" },
  { src: "/img/gente/mayores.jpg", label: "Jubilados" },
  { src: "/img/gente/grupo.jpg", label: "Grupos" },
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 gap-5 pr-5" aria-hidden={hidden || undefined}>
    {FOTOS.map((f, i) => (
      <figure key={f.src} className={`group relative h-64 w-52 shrink-0 overflow-hidden rounded-[1.75rem] sm:h-80 sm:w-64 ${i % 2 ? "translate-y-6" : ""}`}>
        <img src={f.src} alt={hidden ? "" : f.label} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-110" />
        <div className="absolute inset-0 bg-gradient-to-t from-mar/80 via-transparent to-transparent" />
        <figcaption className="absolute bottom-4 left-4 rounded-full bg-white/95 px-3 py-1.5 text-xs font-bold text-mar">{f.label}</figcaption>
      </figure>
    ))}
  </div>
);

export const PeopleStrip = () => (
  <section data-testid="people-strip-section" className="overflow-hidden bg-arena pb-28">
    <div className="mx-auto mb-12 max-w-7xl px-5 sm:px-8 lg:px-16">
      <Reveal>
        <Overline>Para todo tipo de viajero</Overline>
        <h2 className="max-w-3xl font-display text-4xl font-extrabold leading-[0.95] tracking-tight text-mar sm:text-6xl">
          Familias, amigos, parejas <span className="font-serif-i font-normal text-barro">o por trabajo.</span>
        </h2>
      </Reveal>
    </div>
    <div className="marquee-wrap pb-6">
      <div data-testid="people-strip" className="marquee-track flex" style={{ animationDuration: "70s" }}>
        <Row />
        <Row hidden />
      </div>
    </div>
  </section>
);
